<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="secondary">
            <v-toolbar-title>Loading</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="d-flex justify-center">
            <v-progress-circular
              :size="70"
              :width="7"
              indeterminate
              color="error"
            ></v-progress-circular>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {

}
</script>

<style>

</style>